export const formsRu: Record<string, string> = {
  "order.service.audit_free": "Бесплатный DevOps аудит (30-минутный созвон)",
  "order.service.starter_devops": "Starter DevOps - $1,500/месяц (30 часов, SLA 8ч)",
  "order.service.growth_devops": "Growth DevOps - $3,000/месяц (80 часов, SLA 4ч) 🏆",
  "order.service.enterprise_devops": "Enterprise DevOps - $5,000/месяц (160 часов, SLA 1ч)",
  "order.service.k8s_setup": "Kubernetes Setup - $3,000–7,000 (one-time)",
  "order.service.k8s_managed": "Kubernetes Managed - от $500/месяц",
  "order.service.vps_hosting": "VPS-хостинг — от $7.62 в месяц (CX23, биллинг)",
  "order.service.devops_estimate": "Оценка стоимости DevOps",
  "order.service.ddos_protection": "Защита от DDoS",
  "order.service.cicd_implementation": "Внедрение CI/CD",
  "order.service.llmops_private_ai": "LLMOps & Private AI — проект под ключ (Fixed Price)",
  "order.service.devops_general": "DevOps Outsourcing (общий запрос)",
  "order.service.support_247": "Поддержка серверов 24/7 (общий запрос)",

  "order.pageTitle": "Бесплатный аудит DevOps-инфраструктуры",
  "order.pageSubtitle":
    "Получите детальный анализ вашей IT-инфраструктуры и узнайте, как DevOps аутсорсинг может сэкономить до 60% затрат уже в первый месяц",
  "order.formTitle": "Форма бесплатного аудита DevOps",
  "order.formIntro":
    "Два поля — и мы свяжемся с вами. Без длинных опросников и обязательств.",
  "order.label.name": "Имя *",
  "order.label.email": "Email *",
  "order.label.phone": "Телефон",
  "order.label.company": "Компания",
  "order.label.service": "Интересующая услуга *",
  "order.label.projectType": "Выберите тип проекта *",
  "order.label.contact": "Ваш Telegram / WhatsApp для связи *",
  "order.label.message": "Сообщение",
  "order.ph.name": "Ваше имя",
  "order.ph.email": "your@email.com",
  "order.ph.phone": "+380",
  "order.ph.company": "Название компании",
  "order.ph.service": "Выберите услугу",
  "order.ph.projectType": "Выберите тип проекта",
  "order.ph.contact": "@username или +380 XX XXX XX XX",
  "order.ph.message": "Опишите ваши задачи или проблемы...",
  "order.hint.contact": "Проведём 15-минутный разбор вашего стека без обязательств.",
  "order.submit": "Получить бесплатный разбор",
  "order.sending": "Отправка...",
  "order.successTitle": "Аудит инфраструктуры заказан!",
  "order.successText":
    "Спасибо! Мы получили вашу заявку. Наш DevOps эксперт свяжется с вами в течение 24 часов для проведения бесплатного аудита и расчета потенциальной экономии.",
  "order.successAgain": "Заказать еще один аудит",
  "order.mailtoFallback":
    "Почтовый клиент не открылся. Отправьте заявку на email или напишите в Telegram — ответим в течение 24 часов.",
  "order.backServices": "Вернуться к услугам",
  "order.contactTitle": "Связаться с нами",
  "order.contactEmail": "Email",
  "order.contactTg": "Telegram",
  "order.contactPhone": "Телефон",
  "order.benefitsTitle": "Что вы получите?",
  "order.benefit1": "✅ Детальный анализ инфраструктуры",
  "order.benefit2": "✅ Расчет потенциальной экономии",
  "order.benefit3": "✅ Рекомендации по оптимизации",
  "order.benefit4": "✅ План внедрения DevOps",
  "order.benefit5": "✅ Оценка стоимости услуг",
  "order.responseTitle": "Время ответа",
  "order.responseText":
    "Мы отвечаем на все заявки в течение 2 часов в рабочее время (Пн-Пт, 9:00-18:00 по Киеву).",
  "order.mail.subject": "Новый заказ с сайта IT-24.pro",
  "order.mail.infoSubject": "Запрос информации о DevOps услугах",
  "order.mail.bodyTitle": "🔔 Новый заказ с сайта IT-24.pro",
  "order.mail.name": "👤 Имя",
  "order.mail.email": "📧 Email",
  "order.mail.phone": "📱 Телефон",
  "order.mail.contact": "💬 Telegram / WhatsApp",
  "order.mail.company": "🏢 Компания",
  "order.mail.service": "🛠️ Услуга",
  "order.mail.message": "💬 Сообщение",
  "order.mail.time": "⏰ Время",
  "order.mail.na": "Не указан",
  "order.mail.naF": "Не указана",
  "order.mail.naMsg": "Не указано",
  "order.errorSend": "Ошибка отправки сообщения. Попробуйте позже или свяжитесь с нами напрямую.",

  "contacts.title": "Свяжитесь с нами",
  "contacts.subtitle":
    "Готовы обсудить ваш проект? Выберите удобный способ связи или заполните форму обратной связи",
  "contacts.card.phoneTitle": "Телефон",
  "contacts.card.phoneDesc":
    "Предпочитаете живое общение? Позвоните нам, чтобы оперативно обсудить все вопросы и договориться о дальнейших шагов.",
  "contacts.card.mailTitle": "Электронная почта",
  "contacts.card.mailDesc":
    "Напишите на нашу почту с подробным описанием задач или проблем. Мы оперативно ответим и предложим решение.",
  "contacts.card.tgTitle": "Telegram",
  "contacts.card.tgDesc":
    "Напишите нам прямо в Telegram для быстрого ответа! Отправьте сообщение и получите мгновенную поддержку.",
  "contacts.card.formTitle": "Форма обратной связи",
  "contacts.card.formValue": "Онлайн заявка",
  "contacts.card.formDesc":
    "Заполните форму на сайте, чтобы получить быстрый ответ от наших специалистов. Укажите ваши контактные данные и короткое описание проблемы или проекта.",
  "contacts.formTitle": "Форма обратной связи",
  "contacts.label.subject": "Тема *",
  "contacts.ph.subject": "Тема сообщения",
  "contacts.ph.message": "Опишите ваши задачи или вопросы...",
  "contacts.send": "Отправить сообщение",
  "contacts.successTitle": "Сообщение отправлено!",
  "contacts.successText": "Спасибо за ваше сообщение! Мы получили его и свяжемся с вами в ближайшее время.",
  "contacts.sendAgain": "Отправить еще одно сообщение",
  "contacts.hoursTitle": "Рабочие часы",
  "contacts.hoursNote": "⚡ Экстренная поддержка доступна 24/7 для критических инцидентов",
  "contacts.addrTitle": "Адрес",
  "contacts.addrLine": "Украина, Киев",
  "contacts.addrNote": "Работаем удаленно по всей Украине и странам СНГ",
  "contacts.sosTitle": "🚨 Экстренная поддержка",
  "contacts.sosText": "Критический инцидент? Нужна немедленная помощь?",
  "contacts.sosCall": "Срочный звонок",
  "contacts.sosTg": "Telegram SOS",
  "contacts.mail.subjectPrefix": "Сообщение с сайта IT-24.pro:",
  "contacts.mail.bodyTitle": "🔔 Новое сообщение с сайта IT-24.pro",
  "contacts.mail.subjectLine": "📋 Тема",
  "contacts.subjectForService": "Запрос по услуге",
  "contacts.day1": "Понедельник - Пятница",
  "contacts.day2": "Суббота",
  "contacts.day3": "Воскресенье",
  "contacts.time1": "9:00 - 18:00",
  "contacts.time2": "10:00 - 16:00",
  "contacts.time3": "По договоренности",
};
